import { createGlobalRoute } from '@townsquare/router/create-route';

import { discoverResource } from './discover-resource';

export const discoverRouteDefinition = createGlobalRoute({
  exact: true,
  name: 'discover',
  path: '/discover',
  layout: 'home',
  resources: [discoverResource],
});
